var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeSolidFull1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10001 2.3999C1.60314 2.3999 1.20001 2.80303 1.20001 3.2999C1.20001 3.58303 1.33314 3.84928 1.56001 4.0199L5.46001 6.9449C5.78064 7.1849 6.21939 7.1849 6.54001 6.9449L10.44 4.0199C10.6669 3.84928 10.8 3.58303 10.8 3.2999C10.8 2.80303 10.3969 2.3999 9.90001 2.3999H2.10001ZM1.20001 4.8749V8.3999C1.20001 9.06178 1.73814 9.5999 2.40001 9.5999H9.60001C10.2619 9.5999 10.8 9.06178 10.8 8.3999V4.8749L7.08001 7.6649C6.44064 8.1449 5.55939 8.1449 4.92001 7.6649L1.20001 4.8749Z",
    fill: "#3F3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSolidFull1);
export default __webpack_public_path__ + "static/media/envelope-solid-full 1.e1a23fb41c789d4a5c71c31e2a27f24e.svg";
export { ForwardRef as ReactComponent };